<app-import-button 
    [category]="category"
    (uploadDocs)="uploadDocuments($event)"
></app-import-button>